function analyticsSkeletonLoader () {
  return {
    restrict: 'E',
    scope: {
      type: '<',
      size: '<'
    },
    templateUrl: '/analytics/directives/analytics-skeleton-loader/analytics-skeleton-loader-directive.html?$$REVISION$$'
  }
}

export { analyticsSkeletonLoader }
